import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  InputField,
  PhoneInput,
  MyActionButton,
  DashboardIntro,
  MyButton,
} from "../../home/component/Component";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import BestTimeToVisit from "../../home/component/BestTimeToVisit";
import Pricing from "../../home/component/Pricing";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import GenerateDescription from "../utils/GenerateDescription";

const Add = () => {
  const { createOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    tags,
  } = useGeoPositionContext();

  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [title, setTitle] = useState(null);
  const [venue, setVenue] = useState(null);
  const [venueCapacity, setVenueCapacity] = useState(0);
  const [open_days, setStartDate] = useState(
    "Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday"
  );
  const [opened_at, setEndDate] = useState("06:00");
  const [closed_at, setStartTime] = useState("22:00");
  const [email, setEmail] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [countryShort, setCountryShort] = useState("none");
  const [whatsapp, setWhatsapp] = useState("none");
  const [facebook, setFacebook] = useState("none");
  const [twitter, setTwitter] = useState("none");
  const [instagram, setInstagram] = useState("none");
  const [youtube, setYoutube] = useState("none");
  const [hashtags, setHashtags] = useState("");
  const [googleMapCode, setGoogleMapCode] = useState("none");
  const [latitude, setLatitude] = useState("none");
  const [longitude, setLongitude] = useState("none");
  const [formattedAddress, setFormattedAddress] = useState(null);
  const [featured, setFeatured] = useState("no");
  const [promoted, setPromoted] = useState("no");
  const [attractionStatus, setAttractionStatus] = useState(1);
  const [description, setDescription] = useState(null);
  const [repeatEvery, setRepeatEvery] = useState(null);
  const [expo, setExpo] = useState(0);
  const [showTop, setShowTop] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [collection, setCollection] = useState([]);
  const [payLink, setPayLink] = useState(null);

  const [bestTime, setBestTime] = useState([]);
  const [pricing, setPricing] = useState([]);
  const [showDescriptionModal, setShowDescriptionModal] = useState(null);

  const attractionRoutes = "/data/attraction";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    setThumbnail(null);
    setThumbnailId(null);
    setTitle(null);
    setVenue(null);
    setVenueCapacity(0);
    setStartDate(null);
    setEndDate(null);
    setStartTime(null);
    setExpo(0);
    setEmail(null);
    setPhoneNumber(null);
    setPayLink(null);
    setCountryShort("none");
    setWhatsapp("none");
    setFacebook("none");
    setTwitter("none");
    setInstagram("none");
    setYoutube("none");
    setHashtags("none");
    setGoogleMapCode("none");
    setLatitude("none");
    setLongitude("none");
    setFormattedAddress(null);
    setFeatured(0);
    setShowTop(0);
    setDescription(null);
    setRepeatEvery(null);
    setBestTime([]);
    setPricing([]);
  };

  const responses = (isError, msg) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const addOneAttractionHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      setLoading(false);
      return responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "level",
      venue: venue,
      venue_capacity: venueCapacity,
      open_days: open_days,
      opened_at: opened_at,
      closed_at: closed_at,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: `${tags}, ${hashtags}`,
      audio_ad: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: countryShort,
      pay_link: payLink,
      status: attractionStatus,
      featured: featured,
      promoted: promoted,
      repeat_every: repeatEvery,
      expo: expo,
      show_top: showTop,
      best_time_to_visit: bestTime?.length > 0 ? String(bestTime) : null,
      pricing: pricing,
      subdata: collection?.length > 0 ? collection : [],
    };

    const { status, message } = await createOneContent({
      data: data,
      content: _TYPES_.ATTRACTION,
    });
    if (status === 200 || status === 201) {
      cleanFields();
      responses(false, message);
    } else {
      responses(true, message);
    }
  };

  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const section = "rounded-xl border border-gray-200 bg-white shadow-sm";
  const sectionInner = "p-4 sm:p-5";
  const btnBase =
    "inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  const btnPrimary =
    "bg-gray-900 text-white border-gray-900 hover:bg-gray-800 focus-visible:ring-gray-800";

  return (
    <div className="h-full overflow-y-auto bg-white">
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-4">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: attractionRoutes }} />
        </div>

        <div className="mb-6">
          <DashboardIntro
            props={{ intro: `Add Attraction`, name: entry_label }}
          />
        </div>

        {showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null}

        <ModalDetails
          onClick={() => setShowModal(false)}
          showModal={showModal}
          collection={collection}
          setCollection={setCollection}
        />

        <form onSubmit={addOneAttractionHandler}>
          <div className="space-y-6">
            <div className={`${section}`}>
              <div className={sectionInner}>
                <MyMessage
                  error={error}
                  message={message}
                  success={success}
                  onExpired={() => {
                    setError(false);
                    setSuccess(false);
                  }}
                  onClick={() => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage("");
                  }}
                />

                <div className="mb-4">
                  <ImageKitUpload
                    thumbnail={thumbnail}
                    thumbnailId={thumbnailId}
                    setThumbnail={setThumbnail}
                    setThumbnailId={setThumbnailId}
                    folder={image_kit_folder(country_name, FOLDERS.ATTRACTION)}
                  />
                </div>

                <div className="flex items-center justify-between">
                  <Title props={{ title: "Attraction Details" }} />
                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      onClick={() => setShowDescriptionModal(true)}
                      className={`${btnBase} ${btnPrimary}`}
                    >
                      Generate Description
                    </button>
                  </div>
                </div>

                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                  <InputField
                    props={{
                      id: "title",
                      title: "Title",
                      type: "text",
                      required: true,
                      value: title ? title : "",
                      onChange: (e) => {
                        setTitle(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "top",
                      title: "Show In Top Attractions",
                      option: ["no", "yes"],
                      onChange: (e) => {
                        if (e.target.selectedIndex === 0) setShowTop(0);
                        else setShowTop(1);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "venue",
                      title: "Venue",
                      type: "text",
                      value: venue ? venue : "",
                      onChange: (e) => {
                        setVenue(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "formatted_address",
                      title: "Formatted Address",
                      type: "address",
                      value: formattedAddress ? formattedAddress : "",
                      onChange: (e) => {
                        setFormattedAddress(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "venue_capacity",
                      title: "Venue Capacity",
                      type: "number",
                      value: venueCapacity ? venueCapacity : "",
                      onChange: (e) => {
                        setVenueCapacity(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={section}>
              <div className={`${sectionInner} space-y-4`}>
                <Title props={{ title: "Best Time To Visit" }} />
                <BestTimeToVisit
                  bestTime={bestTime}
                  setBestTime={setBestTime}
                />
              </div>
            </div>

            <div className={section}>
              <div className={`${sectionInner}`}>
                <Title props={{ title: "Date & Time" }} />
                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <InputField
                    props={{
                      id: "open_days",
                      title: "Open Days",
                      type: "text",
                      value: open_days ? open_days : "",
                      onChange: (e) => {
                        setStartDate(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "opened_at",
                      title: "Open At",
                      type: "time",
                      value: opened_at ? opened_at : "",
                      onChange: (e) => {
                        setEndDate(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "closed_at",
                      title: "Closed At",
                      type: "time",
                      value: closed_at ? closed_at : "",
                      onChange: (e) => {
                        setStartTime(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>

                <div className="mt-5">
                  <p className="text-xs font-semibold text-gray-900">
                    Repeat Every
                  </p>
                  <div className="mt-2 flex gap-4 overflow-x-auto w-full text-sm py-1">
                    {[
                      "monday",
                      "tuesday",
                      "wednesday",
                      "thursday",
                      "friday",
                      "saturday",
                      "sunday",
                      "annual",
                    ].map((val, key) => (
                      <div
                        key={key}
                        className="flex flex-col items-center capitalize min-w-[72px]"
                      >
                        <p className="text-xs text-gray-700">{val}</p>
                        {repeatEvery?.toString().split("|").includes(val) ? (
                          <MdCheckBox
                            onClick={() => {
                              let rep = "";
                              repeatEvery
                                ?.split("|")
                                .filter((day) => val !== day)
                                .map((weekday) => (rep += `${weekday}|`));
                              setRepeatEvery(rep);
                            }}
                            className="text-2xl text-emerald-600 cursor-pointer"
                          />
                        ) : (
                          <MdCheckBoxOutlineBlank
                            onClick={() => {
                              let rep = "";
                              if (repeatEvery) {
                                [...repeatEvery.split("|"), val].map(
                                  (weekday) => (rep += `${weekday}|`)
                                );
                                setRepeatEvery(rep);
                              } else {
                                setRepeatEvery(val);
                              }
                            }}
                            className="text-2xl text-gray-600 cursor-pointer"
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className={section}>
              <div className={sectionInner}>
                <Title props={{ title: "Pricing" }} />
                <div className="mt-4">
                  <Pricing pricing={pricing} setPricing={setPricing} />
                </div>
              </div>
            </div>

            <div className={section}>
              <div className={sectionInner}>
                <Title props={{ title: "Contact Info" }} />
                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                  <div className="flex flex-row justify-center items-center">
                    <PhoneInput
                      setPhone={setPhoneNumber}
                      phone={phoneNumber}
                      required={false}
                    />
                  </div>
                  <InputField
                    props={{
                      id: "email",
                      title: "Email Address",
                      type: "email",
                      value: email ? email : "",
                      onChange: (e) => {
                        setEmail(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "pay-link",
                      title: "Pay Link (Optional)",
                      type: "text",
                      value: payLink ? payLink : null,
                      onChange: (e) => {
                        setPayLink(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={section}>
              <div className={sectionInner}>
                <Title props={{ title: "Social Contact" }} />
                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  <InputField
                    props={{
                      id: "whatsapp",
                      title: "Whatsapp",
                      type: "text",
                      value: whatsapp ? whatsapp : "",
                      onChange: (e) => {
                        setWhatsapp(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "facebook",
                      title: "Facebook",
                      type: "text",
                      value: facebook ? facebook : "",
                      onChange: (e) => {
                        setFacebook(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "twitter",
                      title: "Twitter",
                      type: "text",
                      value: twitter ? twitter : "",
                      onChange: (e) => {
                        setTwitter(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "instagram",
                      title: "Instagram",
                      type: "text",
                      value: instagram ? instagram : "",
                      onChange: (e) => {
                        setInstagram(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "youtube",
                      title: "YouTube",
                      type: "text",
                      value: youtube ? youtube : "",
                      onChange: (e) => {
                        setYoutube(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={section}>
              <div className={sectionInner}>
                <Title props={{ title: "Geo Position" }} />
                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
                  <InputField
                    props={{
                      id: "google_map_code",
                      title: "Google Map Code",
                      type: "text",
                      value: googleMapCode ? googleMapCode : "",
                      onChange: (e) => {
                        setGoogleMapCode(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "latitude",
                      title: "Latitude",
                      type: "text",
                      value: latitude ? latitude : "",
                      onChange: (e) => {
                        setLatitude(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <InputField
                    props={{
                      id: "longitude",
                      title: "Longitude",
                      type: "text",
                      value: longitude ? longitude : "",
                      onChange: (e) => {
                        setLongitude(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={section}>
              <div className={sectionInner}>
                <Title props={{ title: "More Settings" }} />
                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                  <Select
                    props={{
                      id: "attraction_status",
                      title: "Status",
                      option: ["visible", "invisible"],
                      onChange: (e) => {
                        if (e.target.selectedIndex === 0)
                          setAttractionStatus(1);
                        else setAttractionStatus(0);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "featured",
                      title: "Featured",
                      option: ["no", "yes"],
                      onChange: (e) => {
                        setFeatured(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "promoted",
                      title: "Promoted",
                      option: ["no", "yes"],
                      onChange: (e) => {
                        setPromoted(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                  <Select
                    props={{
                      id: "gallery",
                      title: "Show in Gallery",
                      option: ["no", "yes"],
                      onChange: (e) => {
                        const choice = e.target.value;
                        setExpo(choice === "no" ? 0 : 1);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={section}>
              <div className={`${sectionInner} space-y-4`}>
                <div className="flex items-center gap-3">
                  <button
                    type="button"
                    onClick={() => setShowDescriptionModal(true)}
                    className={`${btnBase} ${btnPrimary}`}
                  >
                    Generate Description
                  </button>
                  <MyButton
                    onClick={() => setShowModal(true)}
                    type="button"
                    title="Add More Details"
                    className={`${btnBase} ${btnPrimary}`}
                  />
                </div>

                <TextArea
                  props={{
                    id: "description",
                    title: "Description",
                    type: "text",
                    value: description ? description : "",
                    onChange: (e) => {
                      setDescription(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <InputField
                    props={{
                      id: "hashtag",
                      title: "Tags (comma separated)",
                      type: "text",
                      value: hashtags ? hashtags : "",
                      onChange: (e) => {
                        setHashtags(e.target.value);
                        setError(null);
                        setSuccess(null);
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-start">
              <MyActionButton
                loading={loading}
                title="Add Attraction"
                onClick={() => {
                  setError(false);
                  setSuccess(false);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Add;
